import { render, staticRenderFns } from "./referenciaDeColoresComponent.vue?vue&type=template&id=9390d4fa"
import script from "./referenciaDeColoresComponent.vue?vue&type=script&lang=js"
export * from "./referenciaDeColoresComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports